<form class="modal-body" [formGroup]="form" (ngSubmit)="update()" novalidate>
  <p class="centermodal__title">{{ 'documents.customizeYourSignature' | translate }}</p>
  <p class="centermodal__description">{{ 'documents.chooseSignatureAppearance' | translate }}</p>

  <div class="centermodal__signaturepad-holder">
    <app-signature-pad
      class="centermodal__signaturepad-component"
      [isLoading]="isLoading"
      [format]="form.get('signature.format').value"
      (formatChange)="form.get('signature.format').setValue($event); form.get('initials.format').setValue($event)"
      [font]="form.get('signature.font').value"
      (signatureTextChange)="form.get('signature.text').setValue($event)"
      (initialsTextChange)="form.get('initials.text').setValue($event)"
      (fontChange)="form.get('signature.font').setValue($event); form.get('initials.font').setValue($event)"
      (canSubmitForm)="canSubmitForm = $event"
      [disableSignature]="disableSignature"
      [disableInitials]="disableInitials"
      [disableFormat]="!!document?.configs?.signature_appearance"
      [step]="isMobile ? signaturePadStep : null"
      #signaturePad
    >
    </app-signature-pad>
    <p class="centermodal__signaturepad-term">{{ 'documents.bySigningYouAgreeToTerms' | translate }}</p>
  </div>

  <div class="centermodal__button-group">
    @if (!isMobile || signaturePadStep === SignaturePadEnum.Signature) {
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.back' | translate }}</button>
    } @else {
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="signaturePadStep = SignaturePadEnum.Signature">{{ 'button.back' | translate }}</button>
    }
    @if (!isMobile || signaturePadStep === SignaturePadEnum.Initials || disableInitials) {
      <button type="submit" class="btn-M btn-filled" [disabled]="isLoading || !canSubmitForm">{{ 'button.forward' | translate }}</button>
    } @else {
      <button type="button" class="btn-M btn-filled" (click)="signaturePadStep = SignaturePadEnum.Initials" [disabled]="isLoading || !canSubmitForm">
        {{ 'button.forward' | translate }}
      </button>
    }
  </div>
</form>
